module.exports = __webpack_public_path__ + "public/img/youzan.7e294c14.png";